module.exports = __webpack_public_path__ + "img/Categories_bg_10.860eb8e3.jpg";